import { PaymentModuleId } from '@foundation/apis/payments';

import { PaymentIntentFlow } from '@/schemas/PaymentIntent';

import { OptionalStartupable } from '../base/Startupable';
import { registerStartupable } from '../base/StartupHelper';
import { paymentInstrumentAuthorize } from '../payments/intent/PaymentIntentApi';
import { createStoredDirectDebitAuthorizationPayload } from '../payments/intent/schemas/AuthorizationPayload';
import PaymentStore from '../payments/PaymentStore';

class PostFinanceService implements OptionalStartupable {
  public readonly name = 'PostFinanceService';
  public readonly moduleId = PaymentModuleId.DirectDebitPostFinance;

  constructor() {
    registerStartupable(this, [PaymentStore]);
  }

  shouldStart(): boolean {
    const isAllowed = PaymentStore.allowedPaymentModules.includes(
      this.moduleId,
    );

    const hasAtLeastOneInstrument =
      PaymentStore.instruments.find((i) => i.moduleId === this.moduleId) !==
      undefined;

    return isAllowed || hasAtLeastOneInstrument;
  }

  startup(): Promise<void> {
    return Promise.resolve();
  }

  public authorize(
    instrumentId: string,
    accessToken: string,
    mandateReference?: string,
  ) {
    return paymentInstrumentAuthorize(
      createStoredDirectDebitAuthorizationPayload(
        PaymentStore.paymentIntentId,
        this.moduleId,
        instrumentId,
        mandateReference,
      ),
      accessToken,
    );
  }

  public async submitPostFinanceForm(
    accountHolderName: string,
    iban: string,
    bankName: string,
    accessToken: string,
  ): Promise<void> {
    if (PaymentStore.flow === PaymentIntentFlow.Manage) {
      if (PaymentStore.legalEntity === undefined) {
        throw new Error('Legal entity cannot be undefined');
      }

      //TODO: implement this
      throw new Error('Not Implemented!!!');
    } else {
      return paymentInstrumentAuthorize(
        {
          paymentIntentId: PaymentStore.paymentIntentId,
          paymentDataTypeId: this.moduleId,
          iban: iban,
          bankName: bankName,
          accountHolderName: accountHolderName,
          paymentDataId: undefined,
        },
        accessToken,
      );
    }
  }
}

export default new PostFinanceService();
